import { Text } from '@vkontakte/vkui';
import React, { type FC, memo, useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { useDuplicatesAnalytic } from 'reactApp/hooks/duplicates/useDuplicatesAnalytic';
import { useDuplicatesRemove } from 'reactApp/hooks/duplicates/useDuplicatesRemove';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './DuplicatesRemoveGroupModal.css';

export interface DuplicatesRemoveGroupModalProps {
    onClose?(): void;
    groupId: string;
}

const modal_type = 'remove-group';

export const DuplicatesRemoveGroupModal: FC<DuplicatesRemoveGroupModalProps> = memo(function DuplicatesRemoveGroupModalProps(props) {
    const { onClose, groupId } = props;

    const { handleDuplicatesRemoveGroup } = useDuplicatesRemove(groupId);

    const analyticData = useDuplicatesAnalytic();

    const renderHeader = useCallback(() => <h3 className={styles.title}>Переместить дубликаты в&nbsp;корзину?</h3>, []);

    const renderContent = useCallback(
        () => <Text className={styles.description}>Останется только лучшее фото&nbsp;&mdash; оно&nbsp;отмечено звёздочкой</Text>,
        []
    );

    const handleClose = useCallback(() => {
        onClose?.();
    }, [onClose]);

    const handleShow = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'modal-show',
            modal_type,
            ...analyticData,
        });
    }, [analyticData]);

    const handleClick = useCallback(async () => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'modal-click',
            modal_type,
            action_type: 'clear',
            ...analyticData,
        });

        handleClose();
        await handleDuplicatesRemoveGroup();
    }, [handleClose, handleDuplicatesRemoveGroup, analyticData]);

    const handleCancel = useCallback(() => {
        sendPaymentGa({
            eventCategory: ECategoryGa.duplicates,
            action: 'modal-click',
            modal_type,
            action_type: 'deny',
            ...analyticData,
        });
    }, [analyticData]);

    return (
        <BaseConfirmDialog
            size="small"
            dataQAId="duplicates-remove-group-modal"
            buttons={[EButtonType.accept, EButtonType.cancel]}
            successButtonText="Переместить"
            cancelButtonText="Не перемещать"
            renderContent={renderContent}
            renderHeader={renderHeader}
            onClose={handleClose}
            onSuccess={handleClick}
            onShow={handleShow}
            onCancel={handleCancel}
        />
    );
});
